const o=()=>{};export{o as noopFn};
